import React, {useState, useEffect} from 'react';
import SoapResponse from '../SoapResponse';
import { properties } from '../../properties';
import ErrorPage from '../../ErrorPage';
import LoaderComp from '../LoaderComp';
import transidgenerator from '../../transidgenerator';
import $ from "jquery";

function SoapTokenRefund({ apiUrl }) {
    const [soapRefund, setSoapRefund] = useState({
        operation: properties.OPERATIONS.tokenrefund,
        vendorid: properties.VENDOR_ID,
        transactionid: transidgenerator(),
        userid: properties.USER_ID,
        customerPresent: properties.CUSTOMER_PRESENT,
        PEDIP: properties.PEDIP,
        method: properties.SOAP_METHOD,
        description: properties.DESCRIPTION,
        value: properties.VALUE,
        currency: properties.CURRENCY,
        timestamp: "",
        region: properties.SEL_REGION,
        token: properties.TOKEN,
        password: properties.PASSWORD,
        security: ""
    });
 
    var canSubmit = true;
 
    function isNotNullCheck(e, field){
        if(e === "" || !e){
            document.getElementsByName(field)[0].classList.add("emptied");
            document.getElementsByName(field)[1].classList.add("emptied");
            canSubmit = false;
        }
        else{
            document.getElementsByName(field)[0].classList.remove("emptied");
            document.getElementsByName(field)[1].classList.remove("emptied");
        }
    }


    const [response, setResponse] = useState();

    function changeTransactionId(e) {
        isNotNullCheck(e.target.value,"WPG_transID");
        setSoapRefund({ ...soapRefund, transactionid: e.target.value });
    }

    function changeVendorId(e) {
        isNotNullCheck(e.target.value,"WPG_vendorID");
        setSoapRefund({ ...soapRefund, vendorid: e.target.value });
    }

    function changePwd(e) {
        isNotNullCheck(e.target.value,"vendorPwd");
        setSoapRefund({ ...soapRefund, password: e.target.value });
    }

    function changeDesc(e) {
        isNotNullCheck(e.target.value,"WPG_description");
        setSoapRefund({ ...soapRefund, description: e.target.value });
    }

    function changeUserId(e) {
        setSoapRefund({ ...soapRefund, userid: e.target.value });
    }

    function changeCustomerPresent(e) {
        isNotNullCheck(e.target.value,"WPG_customerPresent");
        setSoapRefund({ ...soapRefund, customerPresent: e.target.value });
    }

    function changeMethod(e) {
        isNotNullCheck(e.target.value,"WPG_method");
        setSoapRefund({ ...soapRefund, method: e.target.value });
    }

    function changeValue(e) {
        isNotNullCheck(e.target.value,"WPG_value");
        setSoapRefund({ ...soapRefund, value: e.target.value });
    }

    function changeCurrency(e) {
        isNotNullCheck(e.target.value,"WPG_currency");
        setSoapRefund({ ...soapRefund, currency: e.target.value });
    }

    function changeToken(e) {
        isNotNullCheck(e.target.value,"WPG_token");
        setSoapRefund({ ...soapRefund, token: e.target.value });
    }

    function changeRegion(e) {
        isNotNullCheck(e.target.value,"WPG_region");
        setSoapRefund({ ...soapRefund, region: e.target.value });
    }

    var region =[];
 
    for(var property in properties.REGIONS){
        region.push(<option value={property} key={property}>{properties.REGIONS[property]}</option>);
    }

    async function submitTokenRefundForm(e) {
        e.preventDefault();
        isNotNullCheck(soapRefund.transactionid,"WPG_transID");
        isNotNullCheck(soapRefund.vendorid,"WPG_vendorID");
        isNotNullCheck(soapRefund.password,"vendorPwd");
        isNotNullCheck(soapRefund.description,"WPG_description");
        isNotNullCheck(soapRefund.method,"WPG_method");
        isNotNullCheck(soapRefund.customerPresent,"WPG_customerPresent");
        isNotNullCheck(soapRefund.value,"WPG_value");
        isNotNullCheck(soapRefund.region,"WPG_region");
        isNotNullCheck(soapRefund.token,"WPG_token");
        isNotNullCheck(soapRefund.currency,"WPG_currency");
        soapRefund.timestamp = Math.floor(Date.now() / 1000);
        var md5 = require('md5');
        const requestbody =
        {
            vendorID: soapRefund.vendorid,
            transID: soapRefund.transactionid,
            userID: soapRefund.userid,
            method: soapRefund.method,
            customerPresent: soapRefund.customerPresent,
            token: soapRefund.token,
            description: soapRefund.description,
            value: soapRefund.value,
            currency: soapRefund.currency,
            timestamp: soapRefund.timestamp,
            region: soapRefund.region,
            security: md5(soapRefund.vendorid +
                soapRefund.transactionid + soapRefund.userid + soapRefund.method +
                soapRefund.customerPresent + soapRefund.token + soapRefund.description +
                soapRefund.value + soapRefund.currency + soapRefund.timestamp +
                soapRefund.region + soapRefund.password),
        };
        var xmlBody = [];
        xmlBody.push(properties.SOAP_REQUEST_PREFIX + "<ns1:tokenRefund>");
        for (var property in requestbody) {
            xmlBody.push("<" + property + ">" + requestbody[property] + "</" + property + ">");
        }
        xmlBody.push("</ns1:tokenRefund>" + properties.SOAP_REQUEST_SUFFIX);
        xmlBody = xmlBody.join("\n");
        var request = {
            method: 'POST',
            headers: new Headers({
                'Accept-Type': 'text/xml',
                'Content-Type': 'text/xml'
            }),
            body: xmlBody
        };
        if(canSubmit){
            document.getElementsByClassName("loader")[0].classList.add("loading");
            var statusCode;
            if(soapRefund.region === "NoR"){
                setSoapRefund({...soapRefund, region:""});
            }
            fetch(apiUrl, request)
            .then(resp => {
                if(Object.keys(properties.RESPONSE_STATUS_MESSAGE).indexOf(String(resp.status)) === -1){
                    return resp.text();
                }
                else{
                    statusCode = resp.status;
                    throw resp;
                }
            })
            .then(responsedata => setResponse(<SoapResponse title="Token Refund Response" operation="WPG_tokenrefund" message={responsedata} />))
            .catch((error)=>{
                console.log(error);
                setResponse(<ErrorPage code={statusCode} />);
            });
        }
    }
     
    useEffect(() => {
        $(".page-body").scrollTop(0);
    },[]);

    var soapRefundTemplate = (
        <div className="operation-form">
            <h2>Token Refund</h2>
            <form className="form-horizontal" method='post' onSubmit={submitTokenRefundForm}>
                <div className="form-group">
                    <div className="control-label">
                        Client Application ID<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_vendorID" value={soapRefund.vendorid} onChange={changeVendorId} />
                        <div className="error-msg" name="WPG_vendorID">Client Application ID is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Transaction ID<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_transID" value={soapRefund.transactionid} onChange={changeTransactionId} />
                        <div className="error-msg" name="WPG_transID">Transaction ID is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        User ID
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_userid" value={soapRefund.userid} onChange={changeUserId} />
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Customer Present<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <select className="form-control" name="WPG_customerPresent" value={soapRefund.customerPresent} onChange={changeCustomerPresent}>
                            <option value="Y">Yes</option>
                            <option value="N">No</option>
                        </select>
                        <div className="error-msg" name="WPG_customerPresent">Customer Present is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Method<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_method" value={soapRefund.method} onChange={changeMethod} />
                        <div className="error-msg" name="WPG_method">Method is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Description<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_description" value={soapRefund.description} onChange={changeDesc} />
                        <div className="error-msg" name="WPG_description">Description is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Value<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_value" value={soapRefund.value} onChange={changeValue} />
                        <div className="error-msg" name="WPG_value">Value is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        ISO Currency Code<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_currency" value={soapRefund.currency} onChange={changeCurrency} />
                        <div className="error-msg" name="WPG_currency">ISO Currency Code is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Region<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <select className="form-control" name="WPG_region" value={soapRefund.region} onChange={changeRegion}>
                            {region}
                        </select>
                        <div className="error-msg" name="WPG_region">Region is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Token<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_token" value={soapRefund.token} onChange={changeToken} />
                        <div className="error-msg" name="WPG_token">Token is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Client Application Password<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="password" className="form-control" name="vendorPwd" value={soapRefund.password} onChange={changePwd} />
                        <div className="error-msg" name="vendorPwd">Client Application Password is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="col-sm-5">
                        <button type="submit" className="btn btn-primary">Perform</button>
                    </div>
                </div>
            </form>
            <div className="loader-div">
                <span className="loader"><LoaderComp/></span>
            </div>
        </div>
    );

    return response ? response : soapRefundTemplate;
}

export default SoapTokenRefund;